import { Component, Vue } from 'vue-property-decorator';

@Component({})
export class TableStripe extends Vue {
  /**
   * @desc 表格自定义斑马条纹处理
   */
  private mixinTableStripe({ row, rowIndex }: any) {
    if (rowIndex % 2 == 0) {
      return '';
    } else {
      return 'stripe-row-my';
    }
  }
}
